﻿export class Menu {

    ID_TIPO_MENU: number;
    ID_PADRE: number;
    NOMBRE: string;
    DESCRIPCION: string;
    ACTION: string;
    SubMenu: Menu[];
    Collapse: boolean;
    ChildBranchName: string;
    constructor() { }

    static toModel(json: string): Menu {
        const data = JSON.parse(json);
        const toReturn = new Menu();
        toReturn.ID_TIPO_MENU = data.ID_TIPO_MENU;
        toReturn.ID_PADRE = data.ID_PADRE;
        toReturn.NOMBRE = data.NOMBRE;
        toReturn.DESCRIPCION = data.DESCRIPCION;
        toReturn.ACTION = data.ACTION;
        toReturn.SubMenu = data.SubMenu;
        toReturn.Collapse = true;
        toReturn.ChildBranchName = '';
        return toReturn;
    }

}
